export const AUTH_PATHS = ['/login', '/sign-up', '/forgot-password', '/logout'] as const
